// @ts-ignore
import { useInView } from "react-intersection-observer";

import AccountCreation from "@/components/signup/account-creation";
import { JPDOverlayTemplate } from "@/components/signup/layouts";
import { usePremiumIntent, useStandardIntent } from "@/components/user-context";

import { InputSubmitButton, JPDGetStartedHeading } from "../../components";

import {
    FreeSubheading,
    StandardSubheading
} from "./components/free-subheading";

export const LoggedOutJpd = () => {
    const { ref } = useInView();
    const isStandard = useStandardIntent();
    const isPremium = usePremiumIntent();

    if (isStandard || isPremium) {
        return (
            <div ref={ref}>
                <LoggedOutJpdStandardPremium />
            </div>
        );
    }

    return (
        <div ref={ref}>
            <LoggedOutJpdFree />
        </div>
    );
};

const LoggedOutJpdFree = () => (
    <JPDOverlayTemplate size="sm">
        <JPDGetStartedHeading />
        <FreeSubheading />
        <AccountCreation Input={<InputSubmitButton />} Submit={null} />
    </JPDOverlayTemplate>
);

const LoggedOutJpdStandardPremium = () => (
    <JPDOverlayTemplate size="sm">
        <JPDGetStartedHeading />
        <StandardSubheading />
        <AccountCreation Input={<InputSubmitButton />} Submit={null} />
    </JPDOverlayTemplate>
);
